import { type ComponentPropsWithoutRef, type ElementRef, type Ref } from 'react';
import { Button as HeroButton } from '@heroui/react';
import { cn } from '../utils';

type HeroButtonProps = ComponentPropsWithoutRef<typeof HeroButton>;

export type ButtonVariant =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'ghost'
  | 'danger'
  | 'danger-soft';

export interface ButtonProps extends Omit<HeroButtonProps, 'variant'> {
  variant?: ButtonVariant;
}

const buttonClasses: Record<ButtonVariant, string> = {
  primary: 'font-medium shadow-sm shadow-primary/20',
  secondary: 'font-medium',
  tertiary: 'font-medium',
  ghost: 'font-medium',
  danger: 'font-medium shadow-sm shadow-danger/20',
  'danger-soft': 'font-medium'
};

export const Button = ({
  ref,
  className,
  size = 'md',
  variant = 'secondary',
  ...props
}: ButtonProps & { ref?: Ref<ElementRef<typeof HeroButton>> }) => (
  <HeroButton
    ref={ref}
    size={size}
    variant={variant}
    className={cn(
      'transition-[background,border-color,box-shadow,transform] duration-150',
      buttonClasses[variant],
      className
    )}
    {...props}
  />
);

Button.displayName = 'Button';
